import { DateTime } from 'luxon'

import { AVAILABLE_INTERVALS } from './constants'

// eslint-disable-next-line import/prefer-default-export
export const calculateDateRanges = (interval, goLiveDate) => {
  const parsedGoLiveDate = goLiveDate ? DateTime.fromISO(goLiveDate) : null
  if (interval.id === AVAILABLE_INTERVALS.monthly.id) {
    const range = interval.range ?? interval.defaultRange

    const endDate = DateTime.now()
    const startDate = endDate.minus({ month: range - 1 })

    const intervals = []
    let intervalStart =
      startDate < parsedGoLiveDate ? parsedGoLiveDate : startDate.startOf('month')

    while (intervalStart <= endDate) {
      const intervalEnd =
        intervalStart.endOf('month') > endDate ? endDate : intervalStart.endOf('month')

      intervals.push([intervalStart, intervalEnd])
      intervalStart = intervalStart.startOf('month').plus({ months: 1 })
    }

    return intervals
  }
  if (interval.id === AVAILABLE_INTERVALS.weekly.id) {
    const endDate = DateTime.now()
    const startDate = endDate.minus({ week: interval.range ?? interval.defaultRange })

    const intervals = []
    let intervalStart = startDate < parsedGoLiveDate ? parsedGoLiveDate : startDate

    while (intervalStart <= endDate) {
      const intervalEnd =
        intervalStart.plus({ week: 1 }) <= endDate
          ? intervalStart.plus({ week: 1 })
          : endDate

      intervals.push([intervalStart, intervalEnd])
      intervalStart = intervalEnd.plus({ day: 1 })
    }

    return intervals
  }
  throw new Error(`Unexpected interval: ${interval.id}`)
}
